import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

export const apiClientToken = Symbol(
    "apiClientToken"
) as InjectionToken<ApiClientInterface>;
